import React, { useEffect, useState } from 'react';
import './Balloon.css';

export default function Balloon({ type, points, id, onRemove }) {
  const [phase, setPhase] = useState('enter'); // 'enter' | 'explode' | 'done'

  useEffect(() => {
    if (type === 'correct') {
      // Green balloon floats up then fades
      const timer = setTimeout(() => {
        onRemove(id);
      }, 2000);
      return () => clearTimeout(timer);
    } else {
      // Red balloon shakes then explodes
      const shakeTimer = setTimeout(() => {
        setPhase('explode');
      }, 800);
      const removeTimer = setTimeout(() => {
        onRemove(id);
      }, 1500);
      return () => {
        clearTimeout(shakeTimer);
        clearTimeout(removeTimer);
      };
    }
  }, [type, id, onRemove]);

  if (type === 'correct') {
    return (
      <div className="balloon balloon-correct balloon-float">
        <div className="balloon-body">
          <div className="balloon-shine" />
          <span className="balloon-points">+{points}</span>
        </div>
        <div className="balloon-string" />
      </div>
    );
  }

  return (
    <div className={`balloon balloon-wrong ${phase === 'enter' ? 'balloon-shake' : ''} ${phase === 'explode' ? 'balloon-explode' : ''}`}>
      {phase !== 'explode' ? (
        <>
          <div className="balloon-body">
            <div className="balloon-shine" />
            <span className="balloon-points">{points}</span>
          </div>
          <div className="balloon-string" />
        </>
      ) : (
        <div className="balloon-explosion">
          <span className="explosion-points">{points}</span>
          {[...Array(8)].map((_, i) => (
            <div key={i} className="explosion-particle" style={{
              '--angle': `${i * 45}deg`,
              '--distance': `${40 + Math.random() * 30}px`,
            }} />
          ))}
        </div>
      )}
    </div>
  );
}
